<template>
  <v-container class="fill-height justify-center" fluid>
    <offline @detected-condition="handleConnectivityChange"> </offline>
    <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="deep-purple accent-4"></v-progress-linear>

    <v-row align="center" justify="center" class="ac fs18px">
      <v-col>
        <h1 class="mb20px">Offline Enquiries</h1>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" class="ac fs18px">
      <v-col>
        <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" single-line filled rounded dense hide-details></v-text-field>
        <v-data-table :headers="headers" :items="arrItems" :search="search"> </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import offline from "v-offline";
import api from "@/api";

export default {
  name: "ThankYou",
  components: {
    offline
  },
  data: () => ({
    connectionStatus: false,
    search: "",
    arrItems: [],
    headers: [
       
        {
            text: "Segment",
            align: "left",
            sortable: true,
            value: "segment_id"
        },
        {
            text: "Company",
            align: "left",
            sortable: true,
            value: "company_id"
        },
        {
            text: "Contact Person",
            align: "left",
            sortable: true,
            value: "contact_person_id"
        },
    ],
  }),
  async created() {
      this.refresh();
  },
  methods: {
    
    async refresh(){

      this.loading = true;
      this.arrItems = await api.getOfflineEnquiries();
      this.loading = false;
    },
    redirectToHome() {
      window.location.href = "/home";
    },
    handleConnectivityChange(status) {
      this.connectionStatus = status;
      console.log("this.connectionStatus is", this.connectionStatus);
    }
  }
};
</script>
